import React from "react";

function Footer(props) {
  return (
    <div>
      <div className="mt-12 mb-8 bg-gray-800 size-font-4xs text-white text-center p-4">
        © 2025 LoaRoot. This site is not endorsed by Smilegate RPG and does not reflect the views or
        opinions of Smilegate RPG or its affiliates.
      </div>
    </div>
  );
}

export default Footer;
